import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { KbLabFront } from './components/KbLabFront';
import { K5A } from './utils';
let container = null;
((params) => {
    if (params) {
        if (container === null) {
            container = document.getElementById(`guid-${params.guid}`);
        }
        if (container) {
            container.classList.add('kb-labfront');
            const rootElement = ReactDOM.createRoot(container);
            const render = () => { rootElement.render(_jsx(KbLabFront, { config: params })); };
            K5A.init();
            window.addEventListener('hashchange', render);
            render();
        }
    }
})(Object.assign({}, window.kr_plugin_params));
delete window.kr_plugin_params;
